module.exports = __webpack_public_path__ + "static/csvExport-1dd80c0d09877a44180994151c837dc4.gif";